import React, { useState, useRef, useEffect } from "react";
import SvgIcon from "../SvgIcon";
import {
  formatTime,
  getSecondsAndMinutes,
} from "../../utils/converters/time-helper";
import useClickOutside from "../../hooks/useClickOutside";

const TimeInput = ({ defaultValue, name, notAbleToEdit }) => {
  const dropdownRef = useRef(null);

  const [defaultSeconds, defaultMinutes] = getSecondsAndMinutes(defaultValue);

  const [isListOpen, setIsListOpen] = useState(false);
  const [minutes, setMinutes] = useState(defaultMinutes);
  const [seconds, setSeconds] = useState(defaultSeconds);

  useClickOutside(
    dropdownRef,
    () => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsListOpen(false);
      }
    },
    isListOpen
  );
  const handleMinutesChange = (value) => {
    let newMinutes = parseInt(value, 10);

    if (isNaN(newMinutes)) {
      setMinutes(0);
    }
    if (!isNaN(newMinutes) && newMinutes >= 0 && newMinutes <= 60) {
      setMinutes(newMinutes);

      if (newMinutes === 60) {
        setSeconds(0);
      }
    }
  };

  const handleSecondsChange = (value) => {
    let newSeconds = parseInt(value, 10);

    if (isNaN(newSeconds)) {
      setSeconds(0);
    }

    if (!isNaN(newSeconds) && newSeconds >= 0 && newSeconds <= 60) {
      if (minutes < 60 || (minutes === 60 && newSeconds === 0)) {
        setSeconds(newSeconds);
      }
    }
  };

  const toggleList = (e) => {
    if (!notAbleToEdit) {
      e.preventDefault();
      setIsListOpen((prevState) => !prevState);
      if (seconds >= 0 || minutes >= 0) {
      }
    }
  };

  return (
    <>
      <details
        ref={dropdownRef}
        className={
          notAbleToEdit
            ? "disabled-time-input min-and-secs-input"
            : "min-and-secs-input"
        }
        role="list"
        open
      >
        <summary onClick={toggleList}>
          {}
          {/* {defaultTime.current ? formatTime(defaultTime.current) : "-"} */}
          {/* {time ? formatTime(time) : "-"} */}
          {minutes || seconds ? formatTime(minutes * 60 + seconds || 0) : "-"}
          <SvgIcon
            src={
              isListOpen ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"
            }
          />
        </summary>
        <div className={isListOpen ? "opened" : ""}>
          <div className="label-row">
            <label>Min</label>
            <label>Sec</label>
          </div>
          <div className="input-row">
            <input
              autoFocus={true}
              disabled={notAbleToEdit}
              className={`default-time-select-input ${
                minutes === 0 ? "zero-value" : ""
              }`}
              type="number"
              id="default-time-minutes"
              name={`timeMinutes${name}`}
              min="0"
              max="60"
              value={minutes}
              onChange={(e) => {
                handleMinutesChange(e.target.value);
              }}
              maxLength={2}
              onFocus={(e) => {
                if (e.target.value === "0") {
                  e.target.value = "";
                }
              }}
              onBlur={(e) => {
                if (e.target.value === "") {
                  e.target.value = "0";
                }
              }}
              sz="large"
            />
            <span className="time-separator">:</span>
            <input
              disabled={notAbleToEdit}
              className={`default-time-select-input ${
                seconds === 0 ? "zero-value" : ""
              }`}
              type="number"
              id="default-time-seconds"
              name={`timeSeconds${name}`}
              min="0"
              max="60"
              value={seconds}
              onChange={(e) => {
                handleSecondsChange(e.target.value);
              }}
              maxLength={2}
              onFocus={(e) => {
                if (e.target.value === "0") {
                  e.target.value = "";
                }
              }}
              onBlur={(e) => {
                if (e.target.value === "") {
                  e.target.value = "0";
                }
              }}
              sz="large"
            />
            {/* <button data-button-type="primary" onClick={toggleList}>
              Save
            </button> */}
          </div>
        </div>
      </details>
    </>
  );
};

export default TimeInput;
